import { ForexCurrency } from "@/feature/Forex/store/interface";
import { ForexBuyField } from "@/feature/Forex/api/form/forex-form.interface";

// DO NOT CHANGE ORDER
export enum ForexOperationType {
	BUY = 'BUY',
	SELL = 'SELL',
	ALL = 'ALL',
}

export interface ForexCourseByType {
	buy: ForexCourse[]
	sell: ForexCourse[]
}

export interface ForexCourse {
	code: ForexCurrency
	course: number
}

export interface ForexCount {
	template: number
	draft: number
}

export type ForexOperationTypeIndex = {
	[P in ForexOperationType]: number
}

export type ForexOperationTypeFields = {
	[P in ForexOperationType]: ForexBuyField[]
}

export type ForexFilterHandlers = {
	[P in any]?: (value: any) => void // ForexHistoryField
}